// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
/** Serializes successful string fields whose names start with one of the supplied prefixes. */
export function serializeFormFields(form, prefixes) {
  const query = new URLSearchParams();

  for (const [name, value] of new FormData(form)) {
    if (typeof value === "string" && prefixes.some((prefix) => name.startsWith(prefix))) {
      query.append(name, value.replace(/\r?\n/g, "\r\n"));
    }
  }

  return query.toString();
}
